$(document).on('turbo:load', function() {
  const brandFilterContainer = $('.brand-filter-container');
  const brandFilterCount = brandFilterContainer.children().length;

  if (brandFilterContainer.length > 0){
    brandFilterContainer.children().each(function(index) {
      $(this).css('z-index', brandFilterCount - index);
    });
    $('.brand-card').css('z-index', brandFilterCount + 1);
  }

  const sort_by_status = $('#filter-sort-by-status').val();
  const sort_by_group = $('#filter-sort-by-group').val();
  if (sort_by_status === 'brand_status') {
    $('#brand-status-toggle').prop('checked', true).change();
    $('.brand-status-label').toggle();
  }
  if (sort_by_group === 'brand_group') {
    $('#brand-group-toggle').prop('checked', true).change();
    $('.brand-group-label').toggle();
  }

  $('#brand-status-toggle').click(function() {
    $('.brand-status-label').toggle();
  });

  $('#brand-group-toggle').click(function() {
    $('.brand-group-label').toggle();
  });

  let hasHiddenClass = true
  $('.brand-feedback-container .brand-feedback-tooltip').on('click', function() {
    const hiddenInfoText = $('.brand-feedback-container').find('.brand-feedback-text-container')

    if (hasHiddenClass) {
      hiddenInfoText.removeClass('d-none')
      hasHiddenClass = false
    }
    else {
      hiddenInfoText.addClass('d-none')
      hasHiddenClass = true
    }
  })
});

// document on change should always be in .ready(function()) instead of .on('turbo:load', function())
